import { createGlobalStyle, css } from 'styled-components';

import { normalize, reboot } from '@/styleUtils/normalize';
import { slickDefaultStyles } from '@/styleUtils/slick';
import {
  colorBlack900,
  colorBodyBG,
  colorGrey50,
  colorGrey100,
  colorGrey200,
  colorPrimary200,
  colorSecondary200,
} from '@/styleUtils/variables';

const trendStyles = css`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: -8px;
    bottom: 3px;
    width: 0;
    height: 0;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
    border-top: 3px solid ${colorSecondary200};
  }
`;

const getPreloaderStyle = (height) => `
  z-index: 1;
  width: 100%;
  height: ${height};
  overflow: hidden;
  &::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background: linear-gradient(
    90deg,
    ${colorGrey100} 19%,
    ${colorGrey50} 31%,
    ${colorGrey50} 69%,
    ${colorGrey100} 81%
  );
  background-size: 400% 400%;
  animation: lazyload 1s linear infinite;
  }

  @keyframes lazyload {
  0% {
    background-position: 100% 50%;
  }
  }
`;

export const GlobalStyle = createGlobalStyle`
  ${normalize};
  ${reboot};
  ${slickDefaultStyles};

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: ${colorBodyBG};
    overflow-x: clip;
  }
  

  #root {
    box-sizing: border-box;
    color: ${colorBlack900};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.25px;
  }
  
  body[header-styles-loading] {
    header.header {
      position: relative;
      max-width: 1100px;
      ${getPreloaderStyle('56px')};
        
      @media all and (width >= 960px) {
        ${getPreloaderStyle('175px')};
      }    
  
      > * {
        display: none;
      }
    }
  }

  body[footer-styles-loading] {
    footer.footer {
        position: relative;
        ${getPreloaderStyle('300px')};

        > * {
        display: none;
        }
    }
  }
  & table:not(.staticTable):not(.customTable) {
      border-collapse: collapse;
      border: 1px solid #e5e5e5;
      line-height: 20px;
      table-layout: unset;
      text-align: left;
      width: 100%;
      margin-bottom: 16px;

      @media (min-width: 640px) {
          margin-bottom: 24px;
      }

      thead {
          background-color: #f8fafb;
          font-weight: 700;
      }

      tr {
          width: 100%;
          &:not(:last-child) {
              border-bottom: 1px solid #e4eaf4;
          }

          td {
              padding: 16px;
              color: ${colorBlack900};
              min-width: 80px;
          }

          td:first-child {
              min-width: 40px;
          }

          th {
              padding: 16px;
              color: #575757;
              font-weight: normal;
          }
      }
  }
  
  .header,
  .footer {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    z-index: 3;
  }


  .trendUp {
    color: ${colorPrimary200};
    ${trendStyles}
    &::after {
      border-top-color: ${colorPrimary200};
      transform: rotate(-180deg);
      top: 3px;
    }
  }

  .trendDown {
    color: ${colorSecondary200};
    ${trendStyles};
  }

  /* Custom scroll */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    background: ${colorGrey200};
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5);
  }
`;

export default GlobalStyle;
